<template>
  <div class="toast-wrapper">
    <div class="toast">
      Success! {{ msg }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['msg']
}
</script>

<style>
  .toast-wrapper {
    position: fixed;
    width: 100%;
    top: 55px;
  }
  .toast {
    padding: 20px;
    color: white;
    /* background: #ff0062; */
    background: #64f3abfb;
    border-radius: 10px;
    box-shadow: 1px 3px 5px rgba(0,0,0,0.2);
    max-width: 400px;
    margin: 0 auto;
  }
</style>
